import {ProductPropertiesPane} from '../components/NodePropertiesPane.jsx'
import LongText from '../../SidePanel/RightPanel/PropertiesControllerLongText.jsx'
import Text from '../../SidePanel/RightPanel/PropertiesControllerText.jsx'
import Analyse from '../components/PropertiesControllerAnalyse.jsx'
import Om from '../OM/PropertiesControllerOm.jsx'
import Model from './ModelOo.mjs'

export default function PropertiesPaneOo(props) {
    return (
        <ProductPropertiesPane
            controllers={
                <>
                    <Om />
                    <Text prop="ooNo" />
                    <Text prop="ooName" />
                    <LongText prop="ooFullName" />
                    <LongText prop="memo" />
                    <LongText prop="resume" />
                </>
            }

            Model={Model}

            snSuffix={
                <Analyse
                    modes={[
                        'ChgReferenceSingle',
                        'Reference',
                        'ReferenceCall',
                        'IsrfReference',
                    ]}
                />
            }

            {...props}
        />
    )
}
